/*
  Leventh PDP v2 - place the VIEW INGREDIENTS button per breakpoint
  ---------------------------------------------------------------------------
  Figma puts this button UNDER THE GALLERY on desktop and at the TOP OF THE
  INFO COLUMN on mobile. The theme's gallery column (.product__media-wrapper)
  only renders the gallery snippet and accepts no blocks, so there is no
  pure-CSS way to move the button across from the info column: the two columns
  are flex items of .product while the button sits two levels deeper inside the
  other one. Moving the node is therefore the only option. Approved by Harry on
  2026-09-14, see CLAUDE.md N11.

  This file writes NO selector onto a theme class and changes NO theme content:
  it only moves our own link between two places. .product__media-wrapper is
  display: block, so the link dropped into it lands right under the gallery
  with no extra layout CSS.

  The button's home in the info column is [data-leventh-viewing-home], an
  element that always stays put. That way we never have to remember the old
  position in a variable: both ends stay findable by selector, even after the
  theme re-renders the info column.

  Breakpoint changes are caught with matchMedia, an event rather than polling
  (core 4.5). Calling the init any number of times never doubles a handler
  because the listeners are registered once at module scope (core 4.4).

  Known limitation: if the theme re-renders .product__media-wrapper itself, the
  button goes with it. This product has no variants so the gallery is never
  re-rendered; revisit this if a variant is ever added.

  SECOND JOB: scroll to the buy box when a CTA button is clicked.
  The CTA buttons point at #purchase, the id on the benefit list
  ([data-leventh-buy-anchor]). Harry asked on 2026-09-16 for the whole buy box,
  from the benefit list down to Add to cart, to end up in the middle of the
  screen, or at least on screen, after the scroll. The browser's own jump
  cannot do that: it only lines an element up with the top edge, and the list
  sits inside .product__info-wrapper, a theme element with position: sticky,
  whose painted position the browser uses while the page moves, so the landing
  drifts. Measured on the draft 2026-09-14: clicking a CTA near the bottom of
  the page left the Add to cart button flush against the top edge and hidden
  behind the header. So we intercept the click and scroll ourselves. Read the
  comments at the scroll handler for the target and for the sticky column.
  With JavaScript off the browser still jumps to the anchor, and
  scroll-margin-top in leventh-pdp2.css.liquid keeps it clear of the header.
*/
(function () {
  var LINK = '.leventh-buybox__ingredients';
  var HOME = '[data-leventh-viewing-home]';
  var ANCHOR = '[data-leventh-buy-anchor]';
  var GALLERY_CLASS = 'leventh-buybox__ingredients--gallery';
  var mq = window.matchMedia('(min-width: 750px)');

  function place(link) {
    var home = link.closest(HOME) || document.querySelector(HOME);
    if (!home) return;

    var product = home.closest('.product');
    var media = product ? product.querySelector('.product__media-wrapper') : null;

    if (mq.matches && media) {
      if (link.parentElement !== media) media.appendChild(link);
      link.classList.add(GALLERY_CLASS);
    } else {
      if (link.parentElement !== home) home.appendChild(link);
      link.classList.remove(GALLERY_CLASS);
    }
  }

  // Which side the button is already on: true means the gallery column, false
  // means the info column. Remembered so the resize path can bail out straight
  // away while the breakpoint has not been crossed.
  var applied = null;

  function placeAll(force) {
    if (!force && applied === mq.matches) return;
    applied = mq.matches;
    var links = document.querySelectorAll(LINK);
    for (var i = 0; i < links.length; i++) place(links[i]);
  }

  function placeAllForced() {
    placeAll(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeAllForced);
  } else {
    placeAllForced();
  }

  // Re-place when the 750px breakpoint is crossed. matchMedia is the right API
  // here: it fires once on crossing rather than polling (core 4.5).
  // A resize listener is added as a safety net in case a browser does not fire
  // 'change'. It returns on the first line of placeAll while the breakpoint has
  // not been crossed, so it costs nothing even though resize fires often.
  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', function () {
      placeAll(false);
    });
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(function () {
      placeAll(false);
    });
  }

  window.addEventListener('resize', function () {
    placeAll(false);
  });

  document.addEventListener('shopify:section:load', placeAllForced);

  var GAP = 16; // breathing room against the header and the bottom edge

  // Layout position, walking the offsetParent chain. getBoundingClientRect
  // cannot be used for the first estimate: the theme makes the info column
  // position: sticky, and a stuck element reports where it is painted, not
  // where it sits in the document.
  function layoutTop(element) {
    var y = 0;
    for (var node = element; node; node = node.offsetParent) y += node.offsetTop;
    return y;
  }

  // The theme's header hides while the page scrolls down and comes back while
  // it scrolls up, which is the direction every CTA scrolls in, so it covers
  // the top of the screen when the scroll ends. Its section is measured rather
  // than a fixed number: with the header showing on a scrolled page it was
  // 127px at 1512 and 110px at 390 on 2026-09-16.
  function headerHeight() {
    var header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    if (!header) return 0;
    var section = header.closest('.shopify-section') || header;
    return section.getBoundingClientRect().height;
  }

  // The three edges the target is worked out from. The box runs from the top of
  // the benefit list (the anchor) to the bottom of Add to cart; the offer is
  // the part that must never be hidden, from the shipping row down. Add to
  // cart, the shipping row and the Kaching block belong to the theme and to
  // Kaching, so they are only READ here, never styled and never moved; any of
  // them missing falls back to the anchor.
  function partsOf(anchor, product) {
    var kaching = product.querySelector('kaching-bundle');
    return {
      top: anchor,
      bottom: product.querySelector('.product-form__submit') || kaching || anchor,
      offer: product.querySelector('.custom-shipping-container') || kaching || anchor
    };
  }

  // How far the page has to move for the box to land where it should, given
  // the box's top edge, its bottom edge and the offer's top edge, all measured
  // from the top of the screen.
  // - The box fits in the space the header leaves: centre it in that space.
  // - It does not fit: bring Add to cart up to the bottom edge, which gives up
  //   the benefit list first, but never so far that the offer's top edge
  //   slides under the header.
  function shiftFor(boxTop, boxBottom, offerTop) {
    var head = headerHeight();
    var room = window.innerHeight - head;
    var height = boxBottom - boxTop;

    if (height + 2 * GAP <= room) {
      return boxTop - (head + (room - height) / 2);
    }
    return Math.min(boxBottom - (window.innerHeight - GAP), offerTop - (head + GAP));
  }

  // Scroll to the buy box when a CTA button is clicked. Caught with event
  // delegation on document, registered once at module scope so no handler is
  // ever doubled.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var anchor = document.querySelector(ANCHOR);
    if (!anchor || !anchor.id) return;

    var link = target.closest('a[href="#' + anchor.id + '"]');
    if (!link) return;

    var product = anchor.closest('.product');
    if (!product) return; // unfamiliar markup: let the browser jump to the anchor

    event.preventDefault();

    var parts = partsOf(anchor, product);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // First estimate from layout positions. The offsets are all measured from
    // the top of the document here, so the shift is also the target position.
    var top = shiftFor(
      layoutTop(parts.top),
      layoutTop(parts.bottom) + parts.bottom.offsetHeight,
      layoutTop(parts.offer)
    );

    window.scrollTo({
      top: Math.max(top, 0),
      behavior: reduce ? 'auto' : 'smooth'
    });

    // One correction pass, never a loop. Two things can move the target while
    // the page is scrolling: the header changes height once it shrinks, and
    // the theme's info column is position: sticky, so on a page where that
    // column has room to slide the box ends up somewhere other than the layout
    // maths predicts. Re-measure what is actually painted once the scroll has
    // settled and nudge if it is off. If the column really is pinned the nudge
    // changes nothing, which is the correct outcome: that IS as far as the box
    // goes.
    var corrected = false;
    function correct() {
      if (corrected) return;
      corrected = true;
      window.removeEventListener('scrollend', correct);

      var drift = shiftFor(
        parts.top.getBoundingClientRect().top,
        parts.bottom.getBoundingClientRect().bottom,
        parts.offer.getBoundingClientRect().top
      );
      if (Math.abs(drift) < 8) return;
      window.scrollBy({ top: drift, behavior: 'auto' });
    }

    if ('onscrollend' in window) {
      window.addEventListener('scrollend', correct);
    }

    // The correction must never run while the page is still moving, and a fixed
    // timer cannot tell whether it has stopped: a smooth scroll of nine thousand
    // pixels takes far longer than one of two thousand, and longer again on a
    // slow machine or with devtools open. Any timer short enough to feel
    // responsive therefore fires mid-flight on the long scrolls, where it
    // measures a target that has not arrived yet AND, because the nudge is an
    // instant scroll, cancels the smooth scroll where it stands. That was the
    // bug behind "only the button nearest the buy box lands in the right place":
    // that one was simply the only scroll short enough to finish before the
    // 600ms backstop fired. So watch the position and correct once it has
    // stopped changing. The deadline is only a safety net for a scroll the user
    // keeps interrupting, and the minimum wait keeps the very first polls from
    // reading the position before the browser has started moving at all.
    var lastY = -1;
    var stillFor = 0;
    var startedAt = Date.now();
    var minWait = reduce ? 0 : 250;

    (function settle() {
      if (corrected) return;

      var y = window.scrollY;
      stillFor = y === lastY ? stillFor + 1 : 0;
      lastY = y;

      var waited = Date.now() - startedAt;
      if ((stillFor >= 3 && waited > minWait) || waited > 5000) {
        correct();
        return;
      }
      window.setTimeout(settle, 80);
    })();

    // Update the URL without triggering a second jump
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + anchor.id);
    }
  });

  // When the section is removed, send the button back so it disappears with the
  // info column instead of being left behind in the gallery column.
  document.addEventListener('shopify:section:unload', function (event) {
    var links = event.target.querySelectorAll(LINK);
    for (var i = 0; i < links.length; i++) links[i].remove();
  });
})();
